import React, { useState } from 'react';
import { Badge, Button, Card, Col, Container, Form, Row } from 'react-bootstrap';
import FormWrapper from 'components/Wrapper/FormWrapper';

const ContactForm = () => {
    const [message, setMessage] = useState();
    const [contact, setContact] = useState({ firstName: '', lastName: '', email: '', message: '' });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setContact((preValue) => {
            return {
                ...preValue,
                [name]: value
            }
        });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setMessage('Your message was sent successfully.');
    }

    return (
        <FormWrapper animate={{ y: 10 }}>
            <Card className="card-form">
                <Card.Body>
                    <Card.Title>Contact Form</Card.Title>
                    <Form onSubmit={handleSubmit} noValidate>
                        <Row>
                            <Form.Group as={Col} className="mb-3">
                                <Form.Label>First Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name='firstName'
                                    value={contact.firstName}
                                    onChange={handleChange}
                                    maxLength={20} />
                            </Form.Group>
                            <Form.Group as={Col} className="mb-3">
                                <Form.Label>Last Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    name='lastName'
                                    value={contact.lastName}
                                    onChange={handleChange}
                                    maxLength={20} />
                            </Form.Group>
                        </Row>
                        <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control
                                type="email"
                                name='email'
                                value={contact.email}
                                onChange={handleChange}
                                maxLength={50} />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Message</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name='message'
                                value={contact.message}
                                onChange={handleChange}
                                maxLength={200} />
                        </Form.Group>
                        {message && (
                            <Form.Group as={Row} className="mb-3">
                                <Col sm={{ span: 9, offset: 3 }}>
                                    <Badge bg="light" text="danger">{message}</Badge>
                                </Col>
                            </Form.Group>
                        )}
                        <Form.Group className="text-center">
                            <Button type="submit">Send Message</Button>
                        </Form.Group>
                    </Form>
                </Card.Body>
            </Card>
        </FormWrapper>
    )
}

export default ContactForm;